<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="login">Crabs</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" (click)="navbarVer()">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse {{navbarVisible}}" id="navbarNav" >
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li  class="nav-item" *ngFor="let m of direcciones">
          <a class="nav-link" routerLink={{m.direccion}}>{{m.descripcion}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="cliente">Consulta</a>
        </li>
      </ul>
      <form class="d-flex">
        <button *ngIf="cookieValue!== ''" class="btn btn-outline-secondary" type="submit" (click)="verUser()" ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
          <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
        </svg></button>
        <button *ngIf="cookieValue!== ''" class="btn btn-outline-secondary" type="submit" (click)="cerrarSession()" >Cerrar Session</button>
        <button *ngIf="cookieValue=== ''" class="btn btn-outline-secondary" type="button" (click)="nuevoUsuario()">Unirme como cliente</button>

      </form>
    </div>
  </div>
</nav>
<!-- navbar -->

<div class="container">
  <router-outlet ></router-outlet>
</div>
